import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

export default function MapMobileErrorState({
  messages,
  minHeight = 180,
  maxWidth = 240
}) {
  const normalizedMessages = Array.isArray(messages)
    ? messages.filter(Boolean)
    : [messages].filter(Boolean)

  return (
    <Box
      className="map-modal-error"
      sx={{
        minHeight,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        px: 2.5,
        py: 2.5
      }}
    >
      <Box sx={{ maxWidth }}>
        {normalizedMessages.map((message, index) => (
          <Typography
            key={`map-mobile-error-${index}`}
            className="map-error-label"
            sx={{
              fontSize: 14,
              lineHeight: 1.45,
              mb: index === normalizedMessages.length - 1 ? 0 : 1.5
            }}
          >
            {message}
          </Typography>
        ))}
      </Box>
    </Box>
  )
}
